import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/AuthProvider";

/**
 * Efficiently checks individual book access for multiple books in a single query
 * This prevents N+1 query problems and makes book access instant
 */
export function useBatchIndividualAccess(bookIds: number[]) {
  const { session } = useAuth();

  return useQuery({
    queryKey: ['batchIndividualAccess', session?.user?.id, bookIds.sort()],
    queryFn: async () => {
      // Legacy V1 table removed; always return empty access map.
      return new Map<number, boolean>();
    },
    enabled: !!session?.user?.id && bookIds.length > 0,
    staleTime: 30000,
    gcTime: 60000
  });
}

/**
 * Helper hook to check access for a single book from the batch
 */
export function useIndividualBookAccessFromBatch(bookId: number | null, batchAccessMap: Map<number, boolean> | undefined) {
  if (!bookId || !batchAccessMap) return false;
  return batchAccessMap.get(bookId) || false;
}
